import * as React from 'react'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'
import './Breadcrumbs.scss'

interface BreadcrumbsProps {
  children?: React.ReactNode | undefined
}

interface BreadcrumbProps {
  done?: boolean
  active?: boolean
  hideIcon?: boolean
  children?: React.ReactNode | undefined
}


const Breadcrumbs: React.FC<BreadcrumbsProps> = props => {
  return <ul className={`srprs-breadcrumbs`}>{props.children}</ul>
}

const Breadcrumb: React.FC<BreadcrumbProps> = props => {
  const doneClass: string = props.done ? 'is-done' : ''
  const activeClass: string = props.active ? 'is-active' : ''
  return (
    <li className={`${doneClass} ${activeClass}`}>
      <p className={`srprs-label-box`}>
        {props.done ? <Icon icon={UI.checkBreadcrumb} /> : ``}
        {props.children}
      </p>
      {!props.hideIcon ? (
        <p className={`srprs-separator-line`}>
          <Icon
            icon={UI.chevronRight}
            iconProps={{ width: '8px', height: '8px' }}
          />
        </p>
      ) : (
        ''
      )}
    </li>
  )
}

Breadcrumb.defaultProps = {
  done: false,
  active: false,
}

export { Breadcrumbs, Breadcrumb }
